import React from 'react'
import classNames from 'classnames'
import { Icon, Loader } from '@crossfit/ui'

import type { Invitee } from 'types'
import style from './style.module.css'
import { highestUserCredential } from 'utilities/credentials'

type LoadingResultProps = {
  className?: string
}

export function LoadingResult({ className }: LoadingResultProps) {
  return (
    <div className={classNames(style.wrapper, style.loader, className)}>
      <Loader />
    </div>
  )
}

type ErrorResultProps = {
  className?: string
  children: React.ReactNode
}

export function ErrorResult({ children, className }: ErrorResultProps) {
  return (
    <div className={classNames(style.wrapper, style.invalid, className)}>
      {children}
    </div>
  )
}

type ValidInviteeProps = {
  onClick: () => void
  invitee: Invitee
  className?: string
}

export function ValidInvitee({
  className,
  invitee,
  ...props
}: ValidInviteeProps) {
  const { firstName, lastName, email, certifications } = invitee
  const highestCred = highestUserCredential(certifications)
  return (
    <button
      className={classNames(style.wrapper, style.valid, className)}
      type='button'
      aria-label={`${firstName} ${lastName} <${email}>`}
      {...props}
    >
      <div className={style.user}>
        <div className={style.name}>
          {firstName} {lastName}
        </div>
        <div className={style.email}>{email}</div>
      </div>

      <div className={style.certifications}>{highestCred?.level}</div>
    </button>
  )
}

type InvalidInviteeProps = {
  invitee: Invitee
  className?: string
  reasonText: string
  reasonStatus: 'error' | 'notice'
}

export function InvalidInvitee({
  className,
  invitee,
  reasonText,
  reasonStatus,
}: InvalidInviteeProps) {
  const { firstName, lastName, email } = invitee

  return (
    <div className={classNames(style.wrapper, style.invalid, className)}>
      <div className={style.user}>
        <div className={style.name}>
          {firstName} {lastName}
        </div>
        <div className={style.email}>{email}</div>
      </div>

      {reasonStatus === 'error' && (
        <div className={style.error}>
          {reasonText} <Icon name='info' className={style.icon} />
        </div>
      )}

      {reasonStatus === 'notice' && (
        <div className={style.notice}>
          <Icon name='check' className={style.icon} />
          {reasonText}
        </div>
      )}
    </div>
  )
}
